<template>
  <div class="about pa-4">
    <v-snackbar v-model="snackbar" color="white black--text" :timeout="1000" top
      >{{ snackbar_text }}
    </v-snackbar>

    <v-overlay :absolute="true" :value="loading">
      <v-progress-circular
        :size="70"
        :width="7"
        color="yellow"
        indeterminate
      ></v-progress-circular>
    </v-overlay>

    <v-toolbar
      flat
      color="white mb-1 mt-2"
      max-width="100%"
      style="margin: 0 auto;"
    >
      <router-link to="/discord_post">一覧に戻る</router-link>
    </v-toolbar>

    <v-dialog v-model="imgScaleFlg" max-width="800" height="80vh">
      <v-card>
        <v-card-text class="pa-2">
          <v-img
            :src="img_scale_url"
            @click="imgScaleFlg = false"
            contain
          ></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="6">
        <v-card elevation="0" class="pa-3" style="margin: 10px auto;">
          <v-card-title
            >Discord予約投稿
            <v-spacer></v-spacer>

            <v-btn
              color="red white--text"
              min-width="140"
              @click="preview"
              class="mr-2"
            >
              プレビュー
            </v-btn>

            <v-btn color="primary" min-width="140" @click="save">
              予約投稿
            </v-btn>
          </v-card-title>

          <div class="text-right">
            <a
              class="pl-4"
              href="https://discord.com/channels/902455877678792704/948489940575072276"
              target="_blank"
              >▷テストサーバ(Discord)</a
            >
          </div>

          <v-divider></v-divider>
          <v-card-text>
            <table width="100%">
              <tr>
                <th width="80">ID</th>
                <td>{{ id }}</td>
                <th>状態</th><td colspan="3">
                  <!-- <v-btn-toggle v-model="delete_flg" color="orange">
                    <v-btn>投稿予定</v-btn>
                    <v-btn>投稿済み</v-btn>
                  </v-btn-toggle> -->
                  <v-radio-group v-model="delete_flg" row>
                    <v-radio label="投稿予定" value="0"></v-radio>
                    <v-radio label="投稿済み(削除)" value="1"></v-radio>
                  </v-radio-group>

                  <!-- <v-chip class="chips orange white--text">投稿予定</v-chip>
                  <v-chip class="chips">投稿済み</v-chip> -->
                </td>
              </tr>
              </table>

              <table width="100%">
              <tr>
                <th class="pa-2" width="80">設定</th>
                <td colspan="4">
                  <v-select
                    v-model="config_target"
                    :items="config_data"
                    item-text="name"
                    item-value="name"
                    label="設定ファイルから読み込み"
                    persistent-hint
                    return-object
                    single-line
                    @change="selectConfig"
                  ></v-select>
                </td>
              </tr>

              <tr>
                <th><v-icon class="mr-2">mdi-calendar-clock</v-icon></th>
                <td class="pb-3" colspan="4">
                  <VueCtkDateTimePicker
                    v-model="reserve_time"
                    :minute-interval="1"
                    :format="'YYYY-MM-DD HH:mm'"
                    :overlay="true"
                    label="予約投稿日時"
                    :no-label="true"
                  ></VueCtkDateTimePicker>
                </td>
              </tr>

              <tr>
                <th><v-icon class="mr-2">mdi-earth</v-icon></th>
                <td class="pb-3" colspan="3">
                  <v-text-field
                    label="WebフックURL"
                    v-model="webhooks_url"
                    placeholder=""
                    clearable
                    :rules="nameRules"
                  ></v-text-field>
                </td>
              </tr>

              <tr>
                <th style="text-align: center;">
                  <img
                    :src="avatar_url"
                    width="30"
                    height="30"
                    class=""
                    style="border-radius:20px"
                    v-if="avatar_url != null && avatar_url != ''"
                  />
                  <v-icon v-else class="mr-2">mdi-account</v-icon>
                </th>
                <td colspan="4">
                  <v-text-field
                    label="アバターURL"
                    v-model="avatar_url"
                    placeholder=""
                    clearable
                    :rules="nameRules"
                  ></v-text-field>
                </td>
                </tr>
                <tr>
                <th><v-icon class="mr-2">mdi-account</v-icon></th>
                <td colspan="4">
                  <v-text-field
                    label="投稿時のユーザ名(ボット名)"
                    v-model="username"
                    placeholder=""
                    clearable
                    :rules="nameRules"
                  ></v-text-field>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card elevation="0" class="pa-3" style="margin: 10px auto;">
          <div class="pl-3">
            <v-dialog v-model="helpdialog" max-width="800" height="80vh">
                <v-card>
                  <v-card-text class="pa-2">
                    <v-img src="https://tool.matomeroyal.com/wp-content/themes/tool/appmediaTool/discord/discord_setting.webp"></v-img>
                    <div class="pa-2">▼設定変更後、各ユーザのアイコンを右クリック(IDコピー)</div>
                    <v-img src="https://tool.matomeroyal.com/wp-content/themes/tool/appmediaTool/discord/discord_setting2.webp"></v-img>
                  </v-card-text>
                </v-card>
              </v-dialog>
              

            <v-icon class="mr-2">mdi-border-color</v-icon>本文
            (Discord内で作成した文章を貼り付けてください。)

            <div class="red--text">
             <span v-html="mess"></span>
             <span @click="helpdialog = true" color="green" class="blue--text">ユーザIDの取得方法はこちら</span>   
            </div>

            <v-textarea
              outlined
              rows="8"
              auto-grow
              v-model="contents"
              dense
              hide-details="true"
              :rules="nameRules"
            >
            </v-textarea>
          </div>

          <v-file-input
            v-show="0"
            label="画像をアップロード"
            accept="image/*"
            multiple
            hide-input="true"
            hide-details="true"
            @change="handleFileUpload"
            id="fileUpload"
          ></v-file-input>

          <div
            class="drop_area"
            @dragenter="dragEnter"
            @dragleave="dragLeave"
            @dragover.prevent
            @drop.prevent="dropFile"
            @click="showInputFile"
            :class="{ enter: isEnter }"
          >
            <v-icon class="mr-2">mdi-image-outline</v-icon
            >画像ファイルアップロード<br />
            (対応:jpeg,png,webpのみ)
          </div>
          <div v-if="imagePreviews.length > 0">
            <div
              v-for="(preview, index) in imagePreviews"
              :key="index"
              class="pa-2 text-center d-inline-block"
              style="vertical-align:top;"
            >
              <v-card width="220" height="220">
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="deleteImg(index)">
                    <v-icon>mdi-close-box-outline</v-icon>
                  </v-btn>
                </v-card-actions>

                <v-img
                  :src="preview"
                  contain
                  height="160"
                  @click="imgScale(preview)"
                ></v-img>
              </v-card>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
// import Compressor from 'compressorjs'
import { compress } from "squoosh-compress";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  name: "Discord",
  components: {
    VueCtkDateTimePicker: VueCtkDateTimePicker,
  },

  data() {
    return {
      //設定データ(本来は外部DBで作成)
      config_data: [
        {
          name: "ドット勇者【公式】",
          avatar_url:
            "https://appmedia.jp/wp-content/themes/appmedia/images/icon/icon_dotyuusha.webp",
          webhooks_url:
            "https://discord.com/api/webhooks/1196730557846007878/WKGIu7WK9QhYQBpQVk06wsJku-M34zV8OT348ci_NphAs2EltoVsQ_vURWkuHRcbdYI4",
        },

        {
          name: "ポケモン攻略班",
          avatar_url:
            "https://cdn.discordapp.com/avatars/867040055461543936/2e4c3d1a4594ca84d29bde2c83454ec7.webp?size=80",
          webhooks_url:
            "https://discord.com/api/webhooks/1164057128126910544/WLklBEzJoS-tVkHma2Cy1s7oTlqhUAx8BIvG8ygVwF1kx-6p19XtgPFZxAI3RH056kig",
        },
      ],
      config_target: {},

      mess : " ※注意事項：テキストチャンネルは<span style='font-size:120%;font-weight:bold;'><#チャンネルID></span>で投稿してください。<Br /> (例) #テスト → <#1040196310738939914><br />メンションは<span style='font-size:120%;font-weight:bold;'><@ユーザID></span>になります。",

      //画像拡大関連
      imgScaleFlg: false,
      img_scale_url: "",

      //loading
      loading: false,

      //投稿ID
      id: -1,

      //ステータス
      delete_flg: 0,

      //投稿時のユーザ名
      username: "",

      //アバターURL
      avatar_url: "",

      //WebフックURL
      webhooks_url: "",

      //投稿内容
      contents: "",

      //予約日時
      reserve_time: "",

      //保存ボタンの有効か
      save_disabled: true,

      helpdialog: false,

      nameRules: [
        (v) => (v != null && v != "") || "required",
        // v => v.length <= 10 || 'Name must be less than 10 characters',
      ],

      isEnter: false,
      files: [],
      image: null,
      previewImageURL: null,
      selectedFile: null,

      imagePreviews: [],
      imageRowData: [],

      snackbar: false,
      snackbar_text: "",
      colors: ["red", "pink", "purple", "indigo", "blue", "teal", "orange"],
      fontSize: ["body-1", "body-2", "caption"],

      output: [],
      json1: "",
      json2: "",
      json3: "",
      main_id: "815873454594850817",
    };
  },

  mounted() {
    var self = this;

    if (this.$route.params.id == -1) {
      return;
    }

    axios
      .get(process.env.VUE_APP_Discord_POST_DETAIL, {
        params: { id: this.$route.params.id },
      })
      .then((response) => {
        console.log(response.data);
        self.id = response.data.id;
        self.username = response.data.username;
        self.avatar_url = response.data.avatar_url;
        self.webhooks_url = response.data.webhooks_url;
        self.contents = response.data.contents;
        self.reserve_time = response.data.reserve_time;
        self.delete_flg = response.data.delete_flg;
        var id = response.data.id;
        var img_no = response.data.img_num;

        for (var i = 0; i < img_no; ++i) {
          // 画像を読み込む
          const image = new Image();
          image.onload = function() {
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            canvas.width = image.width;
            canvas.height = image.height;
            context.drawImage(image, 0, 0);

            const dataURL = canvas.toDataURL("image/webp");

            self.imagePreviews.push(dataURL);

            canvas.toBlob(function(blob) {
              const file = new File([blob], "image.webp", {
                type: "image/webp",
              });
              self.imageRowData[image.id] = file;
            }, "image/webp"); // ファイル形式を指定
          };
          image.id = i;
          let now = new Date();

          image.src =
            process.env.VUE_APP_Discord_DOMAIN + id + "_" + i + ".webp?"+now.getTime();
          console.log("img=",image.src);
        }

      });
  },

  computed: {
    url() {
      if (this.image === null) {
        return;
      } else {
        return URL.createObjectURL(this.image);
      }
    },
  },

  methods: {
    selectConfig() {
      //投稿時のユーザ名
      this.username = this.config_target.name;
      this.avatar_url = this.config_target.avatar_url;
      this.webhooks_url = this.config_target.webhooks_url;
    },

    imgScale(src) {
      this.img_scale_url = src;
      this.imgScaleFlg = true;
    },

    showInputFile() {
      let fileUpload = document.getElementById("fileUpload");
      if (fileUpload != null) {
        fileUpload.click();
      }
      // console.log();
    },
    dragEnter() {
      console.log("Enter Drop Area");
      this.isEnter = true;
    },
    dragLeave() {
      // this.isEnter = false;
      console.log("Enter dragLeave");
      this.isEnter = false;
    },
    dragOver() {
      console.log("DragOver");
    },
    dropFile() {
      const files = event.dataTransfer.files;
      this.handleFileUpload(files);
      this.isEnter = false;
      console.log("Dropped File");
    },

    async handleFileUpload(files) {
      console.log("SSSS=", files);
      var self = this;
      self.loading = true;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        console.log("AAAA=", file);

        if (file.type.startsWith("image/")) {
          const result = await compress(
            file,
            {
              type: "browser-webp",
              options: {
                quality: 0.75,
              },
            },
            file.name
          );
          const reader = new FileReader();
          reader.onload = (e) => {
            self.imagePreviews.push(e.target.result);
          };
          self.imageRowData.push(result);
          // console.log("result", result);
          reader.readAsDataURL(result);
        }
      }
      self.loading = false;

      //inputのfileで2回同じものを選択するとchangeが効かない問題
      //https://zenn.dev/nana/articles/2b2cc0add0f5b5
      const input = document.getElementById("fileUpload");
      input.addEventListener("click", (e) => {
        e.target.value = "";
      });
    },

    //Discordに投稿(テストカテゴリ)
    preview() {
      if (this.username == "") {
        alert("投稿ユーザ名を入力してください");
        return;
      }
      if (this.avatar_url == "") {
        alert("アバターURLを入力してください");
        return;
      }
      if (this.contents == "") {
        alert("本文を入力してください");
        return;
      }

      var formData = new FormData();

      // var owner = {"username": "mybot"};
      formData.append("username", this.username);
      formData.append("avatar_url", this.avatar_url);

      // var contents = fs.readFileSync('./dmv_file_reader.txt').toString()
      // var blob = new Blob([this.imageRowData[0]], { type: 'image/webp' });
      // var file = new File([blob], "foo.webp", {type: "timage/webp"});

      // var sendFiles = [];
      this.imageRowData.forEach((val, index) => {
        console.log("val", val);
        var blob = new Blob([val], { type: "image/webp" });
        var file = new File([blob], "foo" + index + ".webp", {
          type: "image/webp",
        });
        // sendFiles.push(file);

        formData.append("file[" + index + "]", file);
      });

      //コンテンツURLの埋め込みを無効化
      // 正規表現を使用してURLを検出し、<>で囲む
      var outputText = this.contents.replace(/(https?:\/\/[^\s<>]+)/g, "<$1>");

      formData.append("content", outputText);

      var xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        "https://discord.com/api/webhooks/956734800230776932/BvcOvqfo9PsXaRZxNDZSRroslIpTGUtwEHx7n87nCKz-BSKRkL6DYx0k4qmmR_u45x2R"
      );
      xhr.onload = () => {
        if (xhr.status == "400") {
          alert("Discord(テスト)投稿に失敗しました。");
        } else {
          alert(
            "Discord(テストサーバ)に投稿しました。投稿内容に問題がないか確認してください。"
          );
        }
        // console.log(xhr.status);
      };
      xhr.send(formData);

      // const imageStream = new Buffer.from(this.imagePreviews[0].split("base64,")[1],'base64');
      // https://appmedia.jp/wp-content/uploads/2023/10/20231002utaware0.webp
      // const data = {
      //     content: outputText,
      //     embeds: [{
      //         // id: 0,
      //         // description : "Image of a cute little cat",
      //         image: {url : "https://appmedia.jp/wp-content/uploads/2023/10/20231002utaware0.webp"}

      //     },
      //     {
      //         // id: 0,
      //         // description : "Image of a cute little cat",
      //         image: {url : "https://appmedia.jp/wp-content/uploads/2023/10/20231002utaware0.webp"}
      //     }
      //   ],

      // };
      // axios.post("https://discord.com/api/webhooks/956734800230776932/BvcOvqfo9PsXaRZxNDZSRroslIpTGUtwEHx7n87nCKz-BSKRkL6DYx0k4qmmR_u45x2R", data).then(() => {
      //     this.success_dialog = true;
      // });

      //https://discord.com/api/webhooks/956734800230776932/BvcOvqfo9PsXaRZxNDZSRroslIpTGUtwEHx7n87nCKz-BSKRkL6DYx0k4qmmR_u45x2R
      return;
    },

    save() {
      var message = "データを登録します";
      if (this.id != -1) {
        message = "データを更新します";
      }

      if (!window.confirm(message)) {
        return;
      }
      var self = this;

      if (this.reserve_time == "") {
        alert("投稿日時を設定してください");
        return;
      }
      if (this.username == "") {
        alert("投稿ユーザ名を入力してください");
        return;
      }
      if (this.avatar_url == "") {
        alert("アバターURLを入力してください");
        return;
      }
      if (this.contents == "") {
        alert("本文を入力してください");
        return;
      }
      if (this.webhooks_url == "") {
        alert("WebフックURLを入力してください");
        return;
      }

      self.loading = true;
      axios
        .post(process.env.VUE_APP_Discord_POST, {
          id: this.id,

          img: this.imagePreviews,
          contents: this.contents,
          reserve_time: this.reserve_time,
          webhooks_url: this.webhooks_url,
          username: this.username,

          avatar_url: this.avatar_url,
          delete_flg: this.delete_flg,

          // alt: this.target_title,
        })

        .then((result) => {
          console.log("result", result);
          alert("Discordへの予約投稿が完了しました。");
          // this.imgListDisp();
        })
        .catch((error) => {
          alert("エラー：\n" + error);
        })
        .finally(() => {
          self.loading = false;

          // this.loading = false;
          // this.$refs.img_file.value = null;
        });
    },

    deleteImg(index) {
      this.imagePreviews.splice(index, 1);
      this.imageRowData.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.drop_area {
  color: gray;
  font-weight: bold;
  font-size: 1.2em;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 540px;
  height: 80px;
  margin: 8px auto;
  border: 2px dotted gray;
  border-radius: 10px;
  cursor: pointer;
}
.enter {
  border: 4px dotted powderblue;
  background: #153cd540;
}
</style>
